export default ['api', 'availabilityApiService', function (api, availabilityApiService) {
    return {
        find: (date, eventType, eventId) => {
            return api.get(`/api/${api.property()}/${availabilityApiService.switchEventType(eventType)}/${eventId}/start-times?date=${date}`).
                then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/basket/services/startTime.api.service.js